import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchHealth } from '@/api/health'

export const useConfigStore = defineStore('config', () => {
  const appMode = ref<'demo' | 'prod'>('prod')

  async function loadAppMode(): Promise<void> {
    try {
      const health = await fetchHealth()
      appMode.value = health.mode
    } catch {
      // Fallback to prod on error — safer default
      appMode.value = 'prod'
    }
  }

  return { appMode, loadAppMode }
})
